<hbo-loading></hbo-loading>

<div class="app-wrapper">

  <nav class="app-header navbar navbar-expand bg-body py-3" [hidden]="router.url.includes('login')" *ngIf="user">
    <div class="container-fluid px-4">
      <ul class="navbar-nav">
        <li class="nav-item">
          <a class="nav-link d-sm-none" data-lte-toggle="sidebar" href="#" role="button"><i class="bi bi-list"></i></a>
        </li>
        <li class="nav-item d-none d-md-block">
          <a *ngIf="showBack" [routerLink]="showBack" class="mb-2"><i
              class="nav-arrow bi bi-arrow-left fs-3 link-dark"></i></a>
          <h2 class="fw-bold">{{ currentPage }}</h2>
          <div *ngIf="showCopy" class="copy-to-clipboard-pb" [copy-clipboard]="data_copied" (copied)="notify($event)">
          </div>
        </li>
      </ul>
      <ul class="navbar-nav ms-auto">
        <li *ngIf="configService.currentConfigValue.debug" class="refresh-entities-pb">
          <div (click)="refreshEntities($event)">{{'COMMON.ENTITIES' | translate}}<i class="bi bi-arrow-clockwise"></i>
          </div>
        </li>
        <li class="nav-item dropdown">
          <a class="nav-link" data-bs-toggle="dropdown" href="#">
            <span>{{ ('COMMON.LANGUAGES.' + this.translateService.defaultLang) | translate }}</span>
            <i class="nav-arrow bi bi-chevron-down"></i>
          </a>
          <div class="dropdown-menu dropdown-menu-end">
            <div class="dropdown-item" *ngFor="let lang of availableLanguages" (click)="changeLanguage(lang)">
              {{ ('COMMON.LANGUAGES.' + lang) | translate }}
            </div>
          </div>
        </li>
        <!-- <li class="nav-item dropdown">
          <a class="nav-link" data-bs-toggle="dropdown" href="#">
            <i class="bi bi-bell"></i><span class="navbar-badge badge text-bg-danger">3</span>
          </a>
          <div class="dropdown-menu dropdown-menu-lg dropdown-menu-end">
            <a href="#" class="dropdown-item">
              <div class="d-flex">
                <div class="flex-shrink-0">
                  <img src="assets/images/horizons-logo.png" alt="User Avatar" class="img-size-50 rounded-circle me-3">
                </div>
                <div class="flex-grow-1">
                  <h3 class="dropdown-item-title">
                    Lorem ipsum
                    <span class="float-end fs-7 text-danger"><i class="bi bi-star-fill"></i></span>
                  </h3>
                  <p class="fs-7">Lorem ipsum</p>
                  <p class="fs-7 text-secondary"><i class="bi bi-clock-fill me-1"></i> 4 Hours Ago</p>
                </div>
              </div>
            </a>
            <div class="dropdown-divider"></div>
            <a href="#" class="dropdown-item dropdown-footer">Todas las notificaciones</a>
          </div>
        </li> -->
        <li class="nav-item dropdown user-menu">
          <a href="#" class="nav-link dropdown-toggle" data-bs-toggle="dropdown">
            <!-- <img src="assets/images/horizons-logo.png" class="user-image rounded-circle shadow" alt="User Image"> -->
            <span class="d-none d-md-inline">{{ user.fullname }} <i class="bi bi-chevron-down"></i></span>
          </a>
          <ul class="dropdown-menu dropdown-menu-lg dropdown-menu-end p-2">
            <li class="user-footer cursor-pointer" routerLink="/user/settings">
              <img src="assets/images/gear-icon.png" alt=""> {{ 'COMMON.USER_SETTINGS' | translate }}
            </li>
            <li *ngIf="user.roleId === 1 && user.profileId === 3" class="user-footer cursor-pointer" routerLink="/admin-tools">
              <img src="assets/images/computer.png" alt="" style="width: 20px; height: 20px; margin-right: 8px; padding-left: 2px;"> Admin Tools
            </li>
            <li class="user-footer" role="button" (click)="logOut()">
              <img src="assets/images/exit-icon.png" alt=""> {{ 'COMMON.LOGOUT' | translate }}
            </li>
          </ul>
        </li>
      </ul>
    </div>
  </nav>
  <hbo-admin-tools [show]="adminTools" (callbackAdminTools)="callbackAdminTools($event)"></hbo-admin-tools>
  <aside class="app-sidebar bg-body-secondary shadow" data-bs-theme="dark" [hidden]="router.url.includes('login')"
    *ngIf="user">
    <div class="sidebar-brand">
      <a class="nav-link text-white me-2" data-lte-toggle="sidebar" href="#" role="button"><i
          class="bi bi-list"></i></a>
      <a routerLink="/" class="brand-link">
        <div class="brand-image logo4"></div>
      </a>
    </div>
    <div class="sidebar-wrapper" *ngIf="settings" [class]="settings.layout.sidebar.color === 'black' ? 'inverse' : ''">
      <nav class="mt-2">

        <ul class="nav sidebar-menu flex-column" data-lte-toggle="treeview" role="menu" data-accordion="false">
          <li *ngIf="showDashboard" class="nav-item">
            <a routerLink="/dashboard" class="nav-link" [class]="router.url.includes('/dashboard') ? 'active' : ''">
              <img src="assets/images/icons/dashboard.svg" alt="">
              <p>{{ 'COMMON.DASHBOARD' | translate }}</p>
            </a>
          </li>
          <li *ngIf="mimesysAvailable" class="nav-item">
            <a routerLink="/gaze-maps" class="nav-link" [class]="router.url.includes('/gaze-maps') ? 'active' : ''">
              <img src="assets/images/icons/gaze-maps.svg" alt="">
              <p>{{ 'COMMON.GAZE_MAPS' | translate }}</p>
            </a>
          </li>
          <li *ngIf="user.roleId === 1 && fitAvailable" class="nav-item"
            [class]="router.url.includes('/fits') ? 'menu-open' : ''">
            <a class="nav-link"
              [routerLink]="configService.currentConfigValue.paths && configService.currentConfigValue.paths!['fits'] ? ('/'+configService.currentConfigValue.paths!['fits'].path!+(configService.currentConfigValue.paths!['fits'].subPath ? '/'+configService.currentConfigValue.paths!['fits'].subPath! : '')) : '/fits'">
              <img src="assets/images/icons/fit.svg" alt="">
              <p>{{ 'COMMON.FIT' | translate }} <i class="nav-arrow bi bi-chevron-right"></i></p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <a routerLink="/fits" class="nav-link" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}">
                  <i class="nav-icon bi bi-chevron-right"></i>
                  <p>{{ 'COMMON.FIT' | translate }}</p>
                </a>
              </li>
              <li class="nav-item" *ngIf="user.roleId === 1">
                <a routerLink="/fits/errors" class="nav-link" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}">
                  <i class="nav-icon bi bi-chevron-right"></i>
                  <p>{{ 'COMMON.FIT_ERRORS' | translate }}</p>
                </a>
              </li>
            </ul>
          </li>
          <li *ngIf="user.roleId !== 1 && fitAvailable" class="nav-item"
            [class]="router.url.includes('/fits') ? 'menu-open':''">
            <a routerLink="/fits" class="nav-link">
              <img src="assets/images/icons/fit.svg" alt="">
              <p>{{ 'COMMON.FIT' | translate }}</p>
            </a>
          </li>
          <!-- <li class="nav-item" [class]="(router.url.includes('scanns') || router.url.includes('orders'))  ? 'menu-open menu-open-auto' : ''" *ngIf="false">
            <a href="#" class="nav-link">
              <img src="assets/images/icons/made4you.svg" alt="">
              <p>{{ 'COMMON.MADE4U' | translate }} <i class="nav-arrow bi bi-chevron-right"></i></p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <a routerLink="/scanns" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <i class="nav-icon bi bi-chevron-right"></i>
                  <p>Scanns</p>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/scanns/errors" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <i class="nav-icon bi bi-chevron-right"></i>
                  <p>Scanns Errors</p>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/orders" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <i class="nav-icon bi bi-chevron-right"></i>
                  <p>Orders</p>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/orders/create" class="nav-link" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
                  <i class="nav-icon bi bi-chevron-right"></i>
                  <p>New Order</p>
                </a>
              </li>
            </ul>
          </li> -->
          <li class="nav-item">
            <a routerLink="/settings" class="nav-link" [class]="router.url.includes('/settings') ? 'active' : ''">
              <img src="assets/images/icons/settings.svg" alt="">
              <p>{{ 'COMMON.SETTINGS' | translate }}</p>
            </a>
          </li>
          <li class="nav-item">
            <a routerLink="/entities" class="nav-link" [class]="router.url.includes('/entities') ? 'active' : ''">
              <img src="assets/images/icons/entities.svg" alt="">
              <p>{{ 'COMMON.ENTITIES' | translate }} </p>
            </a>
          </li>
          <li *ngIf="user.roleId !== 4" class="nav-item">
            <a routerLink="/devices" class="nav-link" [class]="router.url.includes('/devices') ? 'active' : ''">
              <img src="assets/images/icons/devices.svg" alt="">
              <p>{{ 'COMMON.DEVICES' | translate }}</p>
            </a>
          </li>
          <li *ngIf="user.roleId !== 1 && user.roleId !== 4"
            [ngClass]="router.url.includes('/licenses') ? 'nav-item menu-open':'nav-item'">
            <a routerLink="/licenses/packages" class="nav-link">
              <img src="assets/images/icons/licenses.svg" alt="">
              <p>{{ 'COMMON.LICENSES' | translate }}</p>
            </a>
          </li>
          <li *ngIf="user.roleId === 1" class="nav-item"
            [ngClass]="router.url.includes('/licenses') ? 'nav-item menu-open':'nav-item'">
            <a class="nav-link"
              [routerLink]="configService.currentConfigValue.paths && configService.currentConfigValue.paths!['licenses'] ? ('/'+configService.currentConfigValue.paths!['licenses'].path!+(configService.currentConfigValue.paths!['licenses'].subPath ? '/'+configService.currentConfigValue.paths!['licenses'].subPath! : '')) : '/licenses/packages'">
              <img src="assets/images/icons/licenses.svg" alt="">
              <p>{{ 'COMMON.LICENSES' | translate }} <i class="nav-arrow bi bi-chevron-right"></i></p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <a routerLink="/licenses/packages" class="nav-link" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}">
                  <i class="nav-icon bi bi-chevron-right"></i>
                  <p>{{ 'COMMON.PACKAGES' | translate }}</p>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/licenses/package-types" class="nav-link" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}">
                  <i class="nav-icon bi bi-chevron-right"></i>
                  <p>{{ 'COMMON.PACKAGE_TYPES' | translate }}</p>
                </a>
              </li>
              <li class="nav-item">
                <a routerLink="/licenses/policies" class="nav-link" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}">
                  <i class="nav-icon bi bi-chevron-right"></i>
                  <p>{{ 'COMMON.POLICIES' | translate }}</p>
                </a>
              </li>
            </ul>
          </li>
          <li *ngIf="user.roleId !== 4" class="nav-item"
            [ngClass]="router.url.includes('/users') ? 'nav-item menu-open':'nav-item'">
            <a class="nav-link"
              [routerLink]="configService.currentConfigValue.paths && configService.currentConfigValue.paths!['users'] ? ('/'+configService.currentConfigValue.paths!['users'].path!+(configService.currentConfigValue.paths!['users'].subPath ? '/'+configService.currentConfigValue.paths!['users'].subPath! : '')) : '/users'">
              <img src="assets/images/icons/users.svg" alt="">
              <p>{{ 'COMMON.USERS' | translate }}
                <i *ngIf="user.roleId === 1 || (user.roleId === 2 && user.teamId === null)"
                  class="nav-arrow bi bi-chevron-right"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <li class="nav-item">
                <a routerLink="/users" class="nav-link" routerLinkActive="active"
                  [routerLinkActiveOptions]="{exact: true}">
                  <i class="nav-icon bi bi-chevron-right"></i>
                  <p>{{ 'COMMON.USERS' | translate }}</p>
                </a>
              </li>
              <ng-container *ngIf="user.roleId !== 4">
                <li *ngIf="user.roleId === 1" class="nav-item">
                  <a routerLink="/users/horizonsteams" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <i class="nav-icon bi bi-chevron-right"></i>
                    <p>{{ 'COMMON.HORIZONS_TEAMS' | translate }}</p>
                  </a>
                </li>
                <li *ngIf="user.roleId === 1 || (user.roleId === 2 && user.teamId === null)" class="nav-item">
                  <a routerLink="/users/teams" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <i class="nav-icon bi bi-chevron-right"></i>
                    <p>{{ 'COMMON.TEAMS' | translate }}</p>
                  </a>
                </li>
              </ng-container>
            </ul>
          </li>
          <li *ngIf="user.roleId !== 4" class="nav-item"
            [ngClass]="router.url.includes('/analytics') ? 'nav-item menu-open':'nav-item'">
            <a class="nav-link"
              [routerLink]="configService.currentConfigValue.paths && configService.currentConfigValue.paths!['analytics'] ? ('/'+configService.currentConfigValue.paths!['analytics'].path!+(configService.currentConfigValue.paths!['analytics'].subPath ? '/'+configService.currentConfigValue.paths!['analytics'].subPath! : '')) : '/analytics/packages'">
              <img src="assets/images/icons/diagnostic_tab.svg" alt="">
              <p>{{ 'Analytics' | translate }}
                <i *ngIf="user.roleId === 1 || (user.roleId === 2 && user.teamId === null)"
                  class="nav-arrow bi bi-chevron-right"></i>
              </p>
            </a>
            <ul class="nav nav-treeview">
              <!--*ngIf="user.roleId !== 4"--><!---liberate analytics to dist and HO-->
              <ng-container>
                <li class="nav-item">
                  <a routerLink="/analytics/packages" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <i class="nav-icon bi bi-chevron-right"></i>
                    <p>{{ 'COMMON.PACKAGES' | translate }}</p>
                  </a>
                </li>
                <li *ngIf="user.roleId === 1 || (mimesysAvailable && user.roleId !== 4)" class="nav-item ">
                  <a routerLink="/analytics/vrresults" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <i class="nav-icon bi bi-chevron-right"></i>
                    <p>{{ 'COMMON.GAZE_MAPS' | translate }}</p>
                  </a>
                </li>
                <!--|| (fitAvailable && user.roleId !== 4)--><!---liberate analytics to dist and HO-->
                <li *ngIf="user.roleId === 1 " class="nav-item nav-item-disabled">
                  <a routerLink="/analytics/fit" class="nav-link" routerLinkActive="active"
                    [routerLinkActiveOptions]="{exact: true}">
                    <i class="nav-icon bi bi-chevron-right"></i>
                    <p>{{ 'COMMON.FIT' | translate }}</p>
                  </a>
                </li>
              </ng-container>
            </ul>
          </li>
          <li *ngIf="user.roleId === 1 && configService.currentConfigValue.debug" (click)="toogleAdminTools()"
            class="nav-admin-tools">
            <i class="bi bi-gear"></i>
          </li>
        </ul>
      </nav>
      <div style="position: absolute; bottom: 0;">
        <div class="sidebar-brand">
          <a routerLink="/" class="brand-link">
            <div class="brand-image logo5"></div>
          </a>
        </div>
        <div class="sidebar-brand">
          <a routerLink="/" class="brand-link">
            <div class="brand-image logo6"></div>
          </a>
        </div>
      </div>
    </div>
  </aside>

  <main *ngIf="showContent" class="app-main" [ngClass]="{'app-main-fade-show':showContent}">
    <div class="app-content">
      <div class="row mx-0 mb-4 tabs-container">
        <ng-container *ngIf="this.router.url.includes('fits') && user.roleId === 1">
          <div class="col-md-3 col-4 p-2 text-center border border-white" routerLink="/fits"
            routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: true}">{{ 'COMMON.FIT' | translate }}
          </div>
          <div class="col-md-3 col-4 p-2 text-center border border-white" routerLink="/fits/errors"
            routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: true}">{{ 'COMMON.FIT_ERRORS' | translate
            }}
          </div>
        </ng-container>
        <ng-container *ngIf="this.router.url.includes('/licenses') && user.roleId === 1">
          <div class="col-md-3 col-4 p-2 text-center border border-white" routerLink="/licenses/packages"
            routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: false}">{{ 'COMMON.PACKAGES' | translate }}
          </div>
          <div class="col-md-3 col-4 p-2 text-center border border-white" routerLink="/licenses/package-types"
            routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: false}">{{ 'COMMON.PACKAGE_TYPES' |
            translate }}
          </div>
          <div class="col-md-3 col-4 p-2 text-center border border-white" routerLink="/licenses/policies"
            routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: false}">{{ 'COMMON.POLICIES' | translate }}
          </div>
        </ng-container>
        <ng-container *ngIf="this.router.url.includes('users') && !this.router.url.includes('admin-tools') && user.roleId !== 4">
          <div *ngIf="!router.url.includes('/users/create')" class="col-md-3 col-4 p-2 text-center border border-white"
            routerLink="/users" routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: true}">{{
            'COMMON.USERS' | translate }}
          </div>
          <div *ngIf="router.url.includes('/users/create')" class="col-md-3 col-4 p-2 text-center border border-white"
            routerLink="/users" routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: false}">{{
            'COMMON.USERS' | translate }}
          </div>
          <div class="col-md-3 col-4 p-2 text-center border border-white" routerLink="/users/horizonsteams"
            routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: false}" *ngIf="user.roleId === 1">{{
            'COMMON.HORIZONS_TEAMS' | translate }}
          </div>
          <div class="col-md-3 col-4 p-2 text-center border border-white" routerLink="/users/teams"
            routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: false}"
            *ngIf="user.roleId === 1 || (user.roleId === 2 && user.teamId === null)">{{
            'COMMON.TEAMS' | translate }}
          </div>
        </ng-container>
        <ng-container *ngIf="this.router.url.includes('/analytics') && user.roleId !== 4">
          <!--disabled -->
          <div class="col-md-3 col-4 p-2 text-center border border-white" routerLink="/analytics/packages"
            routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: false}">{{ 'COMMON.PACKAGES' | translate }}
          </div>
          <div *ngIf="mimesysAvailable" class="col-md-3 col-4 p-2 text-center border border-white " routerLink="/analytics/vrresults"
            routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: false}">{{ 'COMMON.GAZE_MAPS' | translate }}
          </div>
          <!--disabled -->
          <!-- user.roleId === 1 || (fitAvailable && user.roleId !== 4) -->
          <div *ngIf="user.roleId === 1" class="col-md-3 col-4 p-2 text-center border border-white disabled" routerLink="/analytics/fit"
            routerLinkActive="active-tab" [routerLinkActiveOptions]="{exact: false}">{{ 'COMMON.FIT' |
            translate }}
          </div>
        </ng-container>
      </div>
      <div class="container-fluid px-4">
        <div class="row" *ngIf="user?.profileId !== 2">
          <div class="col-2 offset-10 btn btn-dark"
            *ngIf="this.router.url.includes('entities') && !this.router.url.includes('create') && user.roleId !== 4"
            routerLink="/entities/create">{{ 'COMMON.NEW_ENTITY' | translate }}</div>
          <div class="col-2 offset-8"
            *ngIf="this.router.url.includes('devices') && !this.router.url.includes('create') && user.roleId === 1 && configService.currentConfigValue.debug"
            routerLink="/licenses/packages/create">
            <div class="btn btn-dark action_pb">
              <div class="action_new">
                <div class="action_new_icon"></div>
                <div>{{ 'COMMON.NEW_PACKAGE' | translate }}</div>
              </div>
            </div>

          </div>
          <div class="col-2 pb-4" [ngClass]="{'offset-10':!configService.currentConfigValue.debug}"
            *ngIf="this.router.url.includes('devices') && !this.router.url.includes('create') && user.roleId === 1"
            routerLink="/devices/create">
            <div class="btn btn-dark action_pb">
              <div class="action_new">
                <div class="action_new_icon"></div>
                <div>{{ 'COMMON.NEW_DEVICE' | translate }}</div>
              </div>
            </div>
          </div>
          <div class="col-2 offset-10 btn btn-dark"
            *ngIf="this.router.url.includes('package-types') && !this.router.url.includes('create') && user.roleId === 1 && user.profileId === 3"
            routerLink="/licenses/package-types/create">{{ 'COMMON.NEW_PACKAGE_TYPE' | translate }}</div>
          <div class="col-2 offset-10 btn btn-dark"
            *ngIf="this.router.url.includes('policies') && !this.router.url.includes('create') && user.roleId === 1 && user.profileId === 3"
            routerLink="/licenses/policies/create">{{ 'COMMON.NEW_POLICY' | translate }}</div>
          <div class="col-2 offset-10 btn btn-dark"
            *ngIf="this.router.url.includes('users') && !this.router.url.includes('teams') && !this.router.url.includes('create') && user.roleId !== 4"
            routerLink="/users/create">{{ 'COMMON.NEW_USER' | translate }}</div>
          <div class="col-2 offset-10 btn btn-dark"
            *ngIf="this.router.url.includes('users/horizonsteams') && !this.router.url.includes('create') && user.roleId !== 4 && user.profileId === 3"
            routerLink="/users/horizonsteams/create">{{ 'COMMON.NEW_HORIZONS_TEAM' | translate }}</div>
          <div class="col-2 offset-10 btn btn-dark"
            *ngIf="this.router.url.includes('users/teams') && !this.router.url.includes('create') && user.roleId !== 4 && !(user.roleId === 2 && user.profileId != 3)"
            routerLink="/users/teams/create">{{ 'COMMON.NEW_TEAM' | translate }}</div>
        </div>
        <router-outlet></router-outlet>
      </div>
    </div>
  </main>

  <!--<footer class="app-footer" [hidden]="router.url.includes('login')">
    <div class="float-end d-none d-sm-inline">Back Office</div>
    <strong>
      Copyright &copy; 2021&npesbsp;
      <a href="https://horizonsoptical.com/es/" class="text-decoration-none">Horizons Optical</a>.
    </strong>
    All rights reserved.
  </footer>-->

</div>
<hbo-video-modal></hbo-video-modal>
<hbo-regular-progress-modal [footer]="false" [total]="phases" [phasesCompleted]="phasesCompleted" [error]="errorLoading"
  [head5]="totalEntities" (initialized)="onModalEntitiesRendered2()"></hbo-regular-progress-modal>
<hbo-confirmation-modal id="expiredToken" (initialized)="onModalRefreshToken()" [head]="'COMMON.SESIONNEXPIRED'"
  [message]="'COMMON.SESSIONEXPIREDCONTINUE'" (confirm)="refreshLogin($event)" [cancelAction]="'cancel'"
  (cancel)="cancelRefreshLogin($event,'cancel')" [cancelText]="'LOGOUT'"></hbo-confirmation-modal>
<hbo-confirmation-modal id="errorData" [head]="'COMMON.ERROR'" [message]="'COMMON.ERRORCONTINUE'"
  (confirm)="refresh($event)" [hideConfirm]="true" [cancelText]="'COMMON.RELOAD'"></hbo-confirmation-modal>
<hbo-confirmation-modal id="commonMessage" [status]="'success'" [head]="'USER.PASSWORD_CHANGE_HEAD'"
  [message]="'USER.PASSWORD_CHANGE_MAIL'" (confirm)="continue($event)" [hideConfirm]="true"
  [cancelText]="'COMMON.CONTINUE'"></hbo-confirmation-modal>
<hbo-confirmation-modal id="exit" [status]="'warning'" [head]="'MIMESYS.UNSAVED_CHANGES'"
  [message]="'MIMESYS.REFERENCE_NOT_SAVED'" (confirm)="saveRefAndContinue($event)"
  [confirmText]="'MIMESYS.PROCEED_SAVING'" [hideConfirm]="false" [cancelAction]="'cancel'"
  (cancel)="continueNoSaveRef($event)" [cancelText]="'MIMESYS.PROCEED_NO_SAVING'"></hbo-confirmation-modal>
<router-outlet name ="bg-processes"></router-outlet>